import { classNames } from "primereact/utils";
import styles from "./ColorButton.module.scss";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { useSafeId } from "../../tooltip/hooks/useSafeId"; // Update path as needed
import { Icon, IconType } from "../../../icons/Icon";
import { RenderWhen } from "../../../infrastructure/components/RenderWhen";

interface IColorButtonProps {
  className?: string;
  label?: string;
  backgroundColorHex: string;
  textColorHex: string;
  type?: "submit" | "reset" | "button" | undefined;
  disabled?: boolean;
  href?: string;
  loading?: boolean;
  icon?: IconType;
  onClick?: () => void;
  tooltip?: string;
}

export const ColorButton = ({
  className,
  label,
  backgroundColorHex,
  textColorHex,
  type = "button",
  disabled = false,
  href,
  loading = false,
  tooltip,
  icon,
  onClick,
}: IColorButtonProps) => {
  const navigate = useNavigate();
  const tooltipId = useSafeId();

  const isDisabled = disabled || loading;
  const shouldShowTooltip = tooltip && isDisabled;

  return (
    <>
      <button
        style={{ backgroundColor: backgroundColorHex, color: textColorHex }}
        className={classNames(styles.button, className, {
          [styles.button_disabled]: isDisabled,
          [tooltipId]: shouldShowTooltip, // Add tooltip class only when disabled
        })}
        type={type}
        onClick={href && !isDisabled ? () => navigate(href) : onClick}
        disabled={isDisabled}
      >
        <span className={styles.button_contents}>
          <RenderWhen condition={!!icon}>
            <Icon type={icon!} color={textColorHex} />
          </RenderWhen>
          {label}
          {loading && <span className={styles.spinner} />}
        </span>
      </button>

      {shouldShowTooltip && (
        <Tooltip
          anchorSelect={`.${tooltipId}`}
          place="top"
          className={styles.tooltip}
        >
          <div dangerouslySetInnerHTML={{ __html: tooltip }} />
        </Tooltip>
      )}
    </>
  );
};
